<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">账户设置</a></li>
                <li><a href="#">审核开票</a></li>
            </ul>
        </div>

        <div id="usual1" class="usual"> 
            <div class="formbody">
                <div class="formtitle"><span>发票申请</span></div>
                <ul class="forminfo">
                    <li>
                        <label>可申请金额<b>*</b></label>
                        <div class="lh33 left"><label style="color: red;font-size: 13px;">{{summoney}} 元</label></div>
                    </li>
                    <li>
                        <label>开票金额<b>*</b></label>
                        <div class="vocation">
                            <input v-model="money" type="text" onkeyup="this.value=this.value.replace(/\D/g,'')" class="dfinput"
                                onafterpaste="this.value=this.value.replace(/\D/g,'')" placeholder="请输入开票金额"  />
                        </div>
                    </li>
                    <li>
                        <label>发票抬头<b>*</b></label>
                        <div class="vocation">
                            <input v-model="lookedup" type="text" placeholder="请输入发票抬头" class="dfinput" />
                        </div>
                    </li>
                    <li>
                        <label>发票类型<b>*</b></label>
                        <el-radio v-model="invoicetype" label="电子发票" @click="checkinvoicetype(0)" style="border: solid 1px #5da2ff; border-radius: 5px; cursor: pointer;">
                            <label style="margin: -33px 0px 0px 10px;font-size: 14px; cursor: pointer;" @click="checkinvoicetype(0)">电子发票</label>
                        </el-radio>
                        <el-radio v-model="invoicetype" label="普通发票" @click="checkinvoicetype(1)" style="border: solid 1px #5da2ff; border-radius: 5px; cursor: pointer;">
                            <label style="margin: -33px 0px 0px 10px;font-size: 14px; cursor: pointer;" @click="checkinvoicetype(1)">普通发票</label>
                        </el-radio>
                        <el-radio v-model="invoicetype" label="增值税专用发票" @click="checkinvoicetype(2)" style="border: solid 1px #5da2ff; border-radius: 5px; width:130px; cursor: pointer;">
                            <label style="margin: -33px 0px 0px 10px;font-size: 14px; cursor: pointer;" @click="checkinvoicetype(2)">增值税专用发票</label>
                        </el-radio>
                    </li>
                    <li>
                        <label>发票内容<b>*</b></label>
                        <el-radio v-model="invoicecontent" label="电信增值服务" style="border: solid 1px #5da2ff; border-radius: 5px; width:110px; cursor: pointer;">
                            <label style="margin: -33px 0px 0px 10px;font-size: 14px;">电信增值服务</label>
                        </el-radio>
                    </li>
                    <li>
                        <label>纳税人识别号<b>*</b> </label>
                        <input type="text" v-model="taxpayerId" class="dfinput left maringht10" placeholder="请输入纳税人识别号"/>
                    </li>
                    <li v-show="dianzhifp">
                        <label>邮箱地址<b>*</b></label>
                        <input type="text" v-model="email" class="dfinput left maringht10" placeholder="请输入邮箱地址"/>
                    </li>
                    <li v-show="zengzhifp">
                        <label>银行账号<b>*</b></label>
                        <input v-model="cardId" type="text" placeholder="请输入银行账号" class="dfinput left maringht10" />
                    </li>
                    <li v-show="zengzhifp">
                        <label>开户行<b>*</b></label>
                        <input v-model="bank" type="text" placeholder="请输入开户行" class="dfinput left maringht10" />
                    </li>
                    <li v-show="zengzhifp">
                        <label>注册地址<b>*</b></label>
                        <input v-model="corpAddr" type="text" placeholder="请输入注册地址" class="dfinput left maringht10" />
                    </li>
                    <li v-show="zengzhifp">
                        <label>企业电话<b>*</b></label>
                        <input v-model="corpTel" type="text" placeholder="请输入企业电话" class="dfinput left maringht10" />
                    </li>
                    <li v-show="zhizhifp">
                        <label>收件人<b>*</b></label>
                        <input v-model="recipient" type="text" placeholder="请输入收件人" class="dfinput left maringht10" />
                    </li>
                    <li v-show="zhizhifp">
                        <label>邮编<b>*</b></label>
                        <input v-model="code" type="text" placeholder="请输入邮编" class="dfinput left maringht10" />
                    </li>
                    <li v-show="zhizhifp">
                        <label>邮寄地址<b>*</b></label>
                        <input v-model="address" type="text" placeholder="请输入邮寄地址" class="dfinput left maringht10" />
                    </li>
                    <li v-show="zhizhifp">
                        <label>邮寄方式<b>*</b></label>
                        <el-radio v-model="post" label="顺丰到付" style="border: solid 1px #5da2ff; border-radius: 5px; cursor: pointer;">
                            <label style="margin: -33px 0px 0px 10px;font-size: 14px;">顺丰到付</label>
                        </el-radio>
                        <el-radio v-model="post" label="快递邮寄" style="border: solid 1px #5da2ff; border-radius: 5px; cursor: pointer;">
                            <label style="margin: -33px 0px 0px 10px;font-size: 14px;">快递邮寄</label>
                        </el-radio>
                    </li>
                    <li v-show="zhizhifp">
                        <label>固定电话<b>*</b></label>
                        <input v-model="phone" type="text" placeholder="请输入固定电话" class="dfinput left maringht10" />
                    </li>
                    <li v-show="zhizhifp">
                        <label>手机<b>*</b></label>
                        <input v-model="mobile" type="text" placeholder="请输入手机号" class="dfinput left maringht10" />
                    </li>
                    <li>
                        <label>备注<b>*</b></label>
                        <textarea v-model="discription" cols="" rows="" class="textinput left maringht10"  placeholder="备注可选填..."></textarea>
                    </li>
                    <li>
                        <label>&nbsp;</label>
                        <input class="sure" type="button" value="确定提交" @click="tijiao()">&nbsp;
                        <!-- <input class="cancel" type="button" value="重置"> -->
                    </li>
                </ul>
                <div class="jian">&nbsp;</div>
                <div class="welinfo">
                    <span><img src="@/images/dp.png" alt="提醒" /></span>
                    <b>注意</b>
                </div>
                <ul class="infolist">
                    <li><span class="ea2020">关于发票</span></li>
                    <li>1、最小开票金额为1000,1000以上包邮,1000以下请联系客服</li> 
                    <li>2、请仔细核对发票抬头、金额、税号、地址及其他相关信息，因为信息填写错误导致的发票开具、邮寄出错，将不能重开</li>
                    <li>3、发票开具后，除发生开票有误、发票抵扣联、发票联均无法认证等情形外，不予退换</li>
                    <li><span class="ea2020">开票提示</span></li>
                    <li>1、由于税控机的限制，发票抬头如为英文，请不要超过30个字母包含空格。 </li>
                    <li>2、普通客户一天只能申请一张发票，发票会在申请的第三天邮寄出；如果您没有提出开具发票的申请，我们默认您暂时不需要发票。 </li>
                    <li>3 主叫号码和被叫号码可以修改\设置\选取</li>
                    <li>3、如果由于发票中填写的付款单位(个人)名称与实际不符而出现的问题，引起的相关法律责任由提交开发票信息的公司(个人)全部承担；与杭州电码科技有限公司无关。</li>
                    <li>4、发票查询时间：请在发票寄出2个月内查询，邮寄时间超过2个月的发票将不负责为您查询。（因快递公司行业标准查询时间为2个月）</li>  
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    data() {
        return {
            summoney:'',
            money:'',
            lookedup: '',
            invoicetype:'电子发票',
            invoicecontent:'电信增值服务',
            taxpayerId:'',
            cardId: '',
            bank: '',
            corpAddr: '',
            corpTel: '',
            recipient: '',
            code: '',
            address: '',
            post:'顺丰到付',
            phone: '',
            mobile: '',
            discription:'',
            email:'',
            dianzhifp: true,
            zengzhifp: true,
            zhizhifp:true
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted() {
        this.checkinvoicetype(0);
        this.getcanvapplymoney()
    },
    methods: {
        //获得可开票金额
        getcanvapplymoney(){
            var that = this
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/user/canvapplymoney.json",
                data: {},
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if(res.data.code == '0000000')
                {
                    that.summoney = res.data.money
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        checkinvoicetype(type) {
            if(0 == type){
                this.invoicetype = "电子发票";
                this.dianzhifp = true;
                this.zengzhifp = false;
                this.zhizhifp = false;
            }
            else if( 1 == type){
                this.invoicetype = "普通发票";
                this.dianzhifp = false;
                this.zhizhifp = true;
                this.zengzhifp = false;
            }
            else if( 2 == type){
                this.invoicetype = "增值税专用发票";
                this.dianzhifp = false;
                this.zhizhifp = true;
                this.zengzhifp = true;
            }
        },
        tijiao(){
            if(this.money == ''){
                alert("请输入充值金额!");
                return false;
            }
            if(this.money > this.summoney){
                alert("开票金额不能大于可申请发票的金额！");
                return false;
            }
            if(this.money < 100){
                alert("开票金额不能低于100元!");
			    return false;
            }
            if(this.lookedup == ''){
                alert("发票抬头不能为空！");
                return false;
            }
            if(this.taxpayerId == ''){
                alert("纳税人识别号不能为空!");
		        return;
            }
            if(this.invoicetype == '电子发票'){
                if(this.email == ''){
                    alert("邮件地址不能为空！");
		            return;
                }
                this.address = this.email
            }
            else{
                if( this.invoicetype == '增值税专用发票'){
                    if(this.bank == ''){
                        alert("开户行不能为空！");
                        return;
                    }
                    else if(this.cardId == '') {
                        alert("银行账号不能为空！");
                        return;
                    }
                    else if(this.corpAddr == '') {
                        alert("注册地址不能为空！");
                        return;
                    }
                    else if(this.corpTel == '') {
                        alert("企业电话不能为空！");
                        return;
                    }
                }
                if(this.recipient == '') {
                    alert("收件人不能为空！");
                    return;
                }
                if(this.code == '') {
                    alert("邮编号码不能为空！");
                    return;
                }
                if(this.address == '') {
                    alert("邮寄地址不能为空！");
                    return;
                }
                if(this.mobile == '') {
                    alert("手机号不能为空！");
                    return;
                }
                if(this.mobile.length != 11) {
                    alert("请输入11位手机号！");
                    return;
                } 
                if(this.phone == '' || this.phone.length < 10){
                    alert("固定电话不正确，请加区号！");
                    return;
                } 
            }
            var that = this
            let data = {"money":this.money,"lookedup":this.lookedup,"invoicetype":this.invoicetype,"taxpayerID":this.taxpayerId,"cardId":this.cardId,"bank":this.bank,"corpAddr":this.corpAddr,"corpTel":this.corpTel,"recipient":this.recipient,"code":this.code,"address":this.address,"post":this.post,"phone":this.phone,"mobile":this.mobile,"discription":this.discription, "invoicecontent":this.invoicecontent,"sendtime":""};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/user/applyinvoice.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("发票申请成功！")
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        }
    }
}
</script>>



// WEBPACK FOOTER //
// src/components/person/invoiceset.vue